// 网络请求封装
import axios from 'axios'

export async function submitEmail(email) {
  //let uri = "http://localhost:3030/api/email";
  let uri = "https://dnawebsite.mvsdnadev.com/api/email";
  let result = post(uri, {
    email
  });
  return result;
}

// POST方法
export async function post(url, param) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'POST',
      headers: {
        'Content-type': 'application/json'
      },
      data: param,
      json: true
    }).then((response) => {
      resolve(response.data)
    }).catch((e) => {
      reject(e)
    })
  })
}

// GET方法
export async function get(url, param) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'GET',
      headers: {
        'Accept': 'application/problem+json'
      },
      params: param,
    }).then((response) => {
      if (response.data.status.success != 1) {
        throw response.data.status.success
      }
      resolve(response.data.result)
    }).catch((e) => {
      console.log(e.message)
      // 网络异常，静默提示
      if (e.message == 'Network Error') {
        reject(e)
        return
      }
      reject(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/util/http.js